import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const BackToDashboard = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate('/admin/dashboard')}
      sx={{ mb: 2 }}
    >
      Retour au Tableau de Bord
    </Button>
  );
};

export default BackToDashboard;
